export enum UserTypeEnum {
  CONSUMER = 'CONSUMER',
  PARTNER = 'PARTNER',
  DISTRIBUTOR = 'DISTRIBUTOR',
}
